import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import NewDocumentPage from './pages/NewDocumentPage';
import ListPage from './pages/ListPage';
import HistoryPage from './pages/HistoryPage';
import './App.css';

const AppContent: React.FC = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState<'new' | 'list'>('new');

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/history" element={<HistoryPage />} />
          <Route
            path="/"
            element={
              <div className="main-layout">
                <header className="app-header">
                  <div className="tabs">
                    <button
                      className={`tab ${activeTab === 'new' ? 'active' : ''}`}
                      onClick={() => setActiveTab('new')}
                    >
                      {t('new')}
                    </button>
                    <button
                      className={`tab ${activeTab === 'list' ? 'active' : ''}`}
                      onClick={() => setActiveTab('list')}
                    >
                      {t('list')}
                    </button>
                  </div>
                </header>
                <main className="app-content">
                  {activeTab === 'new' ? <NewDocumentPage /> : <ListPage />}
                </main>
              </div>
            }
          />
        </Routes>
      </div>
    </Router>
  );
};

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
